<template>
    <tab-layout :buttons="more.buttons">
        <template slot="title">
            {{ $l10n.__('Conditions Générales') }}
        </template>

        <template slot="content">
            <div class="prelative mt-3" v-if="loading">
                <preloader :display="loading"/>
            </div>
            <div class="flex-column" v-if="!loading">
                <el-table
                    :data="terms"
                    style="overflow-y: auto; width: 100%">
                    <el-table-column
                        :label="$t.__('common.labels.type')"
                        width="100"
                        sortable
                        :sort-method=sortAlphabetically
                        :filters="termsDataFilters"
                        :filter-method="filterIsTermsType"
                        >
                        <template slot-scope="scope">
                            {{ termsData[scope.row.type].short }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t.__('common.labels.contact')"
                        sortable
                        :sort-method=sortAlphabetically
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.type == 'saas_cgu'">
                                {{ scope.row.acceptor.name }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t.__('overview.tabs.TabSamTermsList.current_version')"
                        :filters="[{ text: 'Oui', value: true }, { text: 'Non', value: false }]"
                        :filter-method="filterIsLastVersion"
                        width="180"
                        :align="center">
                        <template slot-scope="scope">
                            {{ scope.row.isLastTermsVersion ? $l10n.__('oui') : $l10n.__('non') | capitalize }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="acceptor"
                        :label="$t.__('overview.tabs.TabSamTermsList.accepted')"
                        width="500"
                        :formatter="formatterAcceptance"
                        >
                    </el-table-column>
                    <el-table-column
                        label="Url"
                        width="150">
                        <template slot-scope="scope">
                            <a :href="scope.row.link" target="_blank">{{ scope.row.version }}</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </template>
    </tab-layout>
</template>

<script>
    import OverviewTabMixin from './OverviewTabMixin'
    import { buildUrl } from '../../../helpers'
    import Preloader from "vcomponents/utilities/Preloader.vue";
    import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';

    export default {
        mixins: [OverviewTabMixin],
        props: {
            more: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                customer: {},
                accounts: [],
                loading: true,
            }
        },
        created(){
            this.fetch()
        },
        computed: {
            buttons(){ return [] },
            parameters() {
                return [
                    {
                        key: 'corpid',
                        value: this.corporation
                    }
                ]
            },
            route(){ return buildUrl(this.more.url, this.parameters) },
            corporation() { return this.$store.getters.dataFetch.sellsyadmin.id },
            terms() {
                let terms = [];
                // Customer
                this.customer.forEach((term) => {
                    terms.push(this.buildTermsObject(term));
                })
                // Accounts
                this.accounts.forEach((account) => {
                    account.map((term) => {
                        terms.push(this.buildTermsObject(term));
                    })
                });
                return terms;           
            },
            termsData() {
                return {
                    saas_cgu : {
                        'label': this.$l10n.__('Conditions Générales d\'Utilisation'),
                        'short': 'CGU'
                    },
                    saas : {
                        'label': this.$l10n.__('Conditions Générales de Vente et d\'Utilisation'),
                        'short': 'CGUV'
                    },
                    affil : {
                        'label': this.$l10n.__('Conditions Générales de Parrainage'),
                        'short': 'CGP'
                    },
                };
            },
            termsDataFilters() {
                let filters = [];
                Object.keys(this.termsData).forEach((key) => {
                    filters.push({
                        text: this.termsData[key].label,
                        value: key
                    });
                })
                return filters;
            }
        },
        methods: {

            addTermsInList(list, terms) {
                list.push(terms);
            },
            buildTermsObject(term) {
                return {
                    type: term.type,
                    version: term.version,
                    date: term.created,
                    acceptor: null == term.acceptor ? {} : {
                        name: term.acceptor.name,
                        email: term.acceptor.email,
                    },
                    status: term.status,
                    link: term.url,
                    isLastTermsVersion: term.isLastTermsVersion
                }
            },
            fetch() {
                this.loading = true
                this.$ajax.get(this.route, {}, (response) => {
                    this.customer = response.customer;
                    this.accounts = response.accounts;
                    this.loading  = false
                })
            },
            formatterAcceptance(row) {
                if (row.status !== 'accepted') {
                    return '-'
                }
                return this.$l10n.__('Le %(date)s par %(name)s (%(email)s)', { 
                    date: this.$options.filters.dateFormatter(moment(row.date).unix(), 'NORMAL_DATE_TIME_WITH_DAY', false), 
                    name: row.acceptor.name || this.$l10n.__('N/C'),
                    email: row.acceptor.email || this.$l10n.__('N/C'),
                });
            },
            sortAlphabetically(currentStr, nextStr) {
                return currentStr == [currentStr, nextStr].sort()[0]
            },
            filterIsLastVersion(value, row) {
                return row.isLastTermsVersion === value;
            },
            filterIsTermsType(value, row) {
                return row.type === value;
            },
            buildUrl
        },
        components: {
            Preloader,
            TabLayout,
        }
    }
</script>

<style scoped>

</style>